import { useMemo } from 'react';

import { ImageUpload, ImageUploadProps, Text } from '@pukka/ui-components';
import { useSnapshot } from 'valtio';

import { FormInput } from './FormInput';
import { getFileValue, IndividualFormState, onUpload, ValidationState } from './GopayActivationForm.state';

interface IndividualUploadFormProps {
  readonly IndividualState?: typeof IndividualFormState;
  readonly Validation?: typeof ValidationState;
}

const MAX_FILE_MB_SIZE = 2;

const RULE: ImageUploadProps<unknown>['rule'] = {
  maxCount: 1,
  maxSize: [MAX_FILE_MB_SIZE * 1_000_000, `Max size is ${MAX_FILE_MB_SIZE} MB`],
  errorMessage: 'This is a required question',
};

function IndividualUploadForm({ IndividualState = IndividualFormState, Validation = ValidationState }: IndividualUploadFormProps) {
  const { dirty, idUpload, npwpUpload } = useSnapshot(IndividualState);
  const { individualValidation } = useSnapshot(Validation);

  const idUploadValue = useMemo(() => {
    return getFileValue(idUpload);
  }, [idUpload]);

  const npwpUploadValue = useMemo(() => {
    return getFileValue(npwpUpload);
  }, [npwpUpload]);

  return (
    <div>
      <Text as="h3" variant="title-2" weight="bold" className="mb-4" color="blue">
        Dokumentasi Individu
      </Text>
      <FormInput
        required
        label="Foto KTP/KITAS"
        description="KITAS diperlukan jika direktur adalah WNA (Warga Negara Asing)."
        error={dirty.has('idUpload') && !individualValidation.idUpload.success && individualValidation.idUpload.error}
      >
        <ImageUpload testId="idUpload" ordering={false} rule={RULE} images={idUploadValue} onUpdate={onUpload('individual', 'idUpload')} />
      </FormInput>
      <FormInput
        required
        label="Foto NPWP Pribadi"
        description="Jika tidak memiliki NPWP silahkan upload foto KTP."
        error={dirty.has('npwpUpload') && !individualValidation.npwpUpload.success && individualValidation.npwpUpload.error}
      >
        <ImageUpload
          testId="npwpUpload"
          ordering={false}
          rule={RULE}
          images={npwpUploadValue}
          onUpdate={onUpload('individual', 'npwpUpload')}
        />
      </FormInput>
    </div>
  );
}

export { IndividualUploadForm };
